import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Ezmeral = props => (
  <StyledIcon viewBox='0 0 48 24' a11yTitle='Ezmeral' {...props}>
    <path d='M7 8H41V16H7V8Z' fill='#01A982' /><path d='M1 8H7V16H1V8Z' fill='#00775B' /><path d='M41 8H47V16H41V8Z' fill='#00775B' /><path d='M7 16H41V22H7V16Z' fill='#00775B' /><path d='M7 2H41V8H7V2Z' fill='#00C781' /><path d='M1 8L7 2V8H1Z' fill='#01A982' /><path d='M1 16L7 22V16H1Z' fill='#01A982' /><path d='M47 8L41 2V8H47Z' fill='#01A982' /><path d='M47 16L41 22V16H47Z' fill='#01A982' />
  </StyledIcon>
);
